import formatMediaObject from '../utils/formatters/format-media-object';

/**
 * Format Recipe Listings API data.
 *
 * @param {object} context
 * @param {Array} listings
 *
 * @returns {Array}
 */
export const formatRecipeListings = (context, listings = []) => {
    return listings.map(({ attributes }) => ({
        name: attributes.name,
        description: attributes.description,
        image: formatMediaObject.call(context, attributes.desktop_image),
        to: attributes.page?.data?.attributes?.uri,
        note: attributes.recipe_tag,
    }));
};

/**
 * Format Recipe Categories API data.
 *
 * @param {Array} categories
 *
 * @returns {Array}
 */
export const formatRecipeCategories = (categories = []) => {
    return categories.map(({ attributes }) => ({
        text: attributes.name,
        value: attributes.slug,
    }));
};

/**
 * Format recipes for display in their card form.
 *
 * @param {object} context
 * @param {Array} recipes
 *
 * @returns {{image: {src: string, alt: string}, note: string, name: string, description: string, to: string}[]}
 */
export const formatRecipesForCards = (context, recipes = []) => {
    return recipes.map(({ attributes }) => ({
        name: attributes.name,
        description: attributes.description,
        image: formatMediaObject.call(context, attributes.desktop_image),
        to: attributes.page?.data?.attributes?.uri,
        note: attributes.recipe_tag,
    }));
};
